@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';
@import (reference) '../settings-page.module.less';

/* Add-On Marketplace Page*/
@addons-page-width: 1136px;

.addons-page-content {
  background-color: @seller-settings--page--background-color;
  padding: @settings-page-content-padding;
  overflow-y: auto;
  height: 100%;
}

.shipstation-notification-text {
  margin-bottom: @space-8;
}

.addons-wrapper {
  display: flex;
  flex-direction: column;
  max-width: @addons-page-width;
}

.right-arrow-icon {
  height: 16px;
  display: inline-block;
  vertical-align: middle;
}

.go-to-api-keys-link {
  margin-bottom: 0;
  display: inline-block;
  margin-right: @space-4;
}

/* Add-on grid */
.grid-header {
  margin: @space-32 0 @space-16;
}

.addon-grid {
  display: flex;
  flex-wrap: wrap;
  gap: @space-24;

  &.empty {
    background-color: var(--white);
    padding: @space-24 0;
    border: 1px solid var(--default--border-color--10);
    border-radius: 4px;
    margin-bottom: @space-32;
  }

  .placeholder-image {
    width: 100%;
    text-align: center;
  }

  .empty-box {
    height: 142px;
  }

  .empty-header {
    width: 100%;
    text-align: center;
    color: @seller-setting--text--font-color;
    font-weight: 500;
  }

  .empty-note {
    width: 100%;
    text-align: center;
    color: @seller-setting--text--font-color;
    margin-top: -10px;
  }
}
